import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import toast from 'react-hot-toast';
import { AuthContext } from '../../context/auth.context';
import { AuthService } from '../../services';
import { PasswordActive, PasswordInactive } from '../../assets/icons';
import { LoginBanner, Logo } from '../../assets/img';
import { Input } from "../../components";

const Login = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);
  const { form, isLoading, onChange, onSubmit } = useForm();

  return (
    <div className="flex min-h-screen w-full bg-white font-sans overflow-hidden">

      <div className="flex flex-col justify-center items-center w-full lg:w-1/2 p-8 lg:p-24">
        <div className="w-full max-w-sm flex flex-col items-center">

          <div className="mb-12">
            <img
              src={Logo}
              alt="Maxer Trans Logo"
              className="h-auto w-64"
            />
          </div>

          <form className="w-full space-y-4" onSubmit={onSubmit}>
            <div className="relative">
              <Input
                type="email"
                placeholder="Correo electrónico"
                value={form.email}
                onValueChange={v => onChange(v, 'email')}
              />
            </div>
            <div className="relative">
              <Input
                type={isVisible ? 'text' : 'password'}
                placeholder="Contraseña"
                value={form.password}
                onValueChange={v => onChange(v,'password')}
                append={
                  <button
                    type="button"
                    onClick={toggleVisibility}
                    className=" text-gray-400"
                  >
                    <img src={isVisible ? PasswordActive : PasswordInactive} className="w-6 h-6" alt="" />
                  </button>
                }
              />
            </div>

            <button
              className="w-full bg-red hover:bg-red-700 text-white font-bold py-3 rounded-2xl shadow-lg transition-colors text-xl mt-6"
              disabled={isLoading}
            >
              Iniciar sesión
            </button>
          </form>

          <Link to="/recover" className="mt-8 bg-[#F1F3F4] text-gray-700 px-6 py-2 rounded-xl font-medium hover:bg-gray-200 transition-colors">
            Olvidé mi contraseña
          </Link>
        </div>
      </div>

      <div className="hidden lg:flex relative w-1/2">
        <img
          src={LoginBanner}
          className="w-full h-screen object-cover"
          alt="City background"
        />
      </div>
    </div>
  )
}

const useForm = () => {
  const { login } = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (!form.email)
      return onError('Debe ingresar el correo');

    if (!form.password)
      return onError('Debe ingresar la contraseña');

    if (String(form.password).length < 6)
      return onError('La contraseña debe tener al menos 6 caracteres');

    return true;
  }

  const submit = async (event) => {
    event.preventDefault();
    if (!isValidForm()) return;
    setIsLoading(true);

    try {
      const session = await AuthService.login(form);
      login(session.user?.user);
      dispatch({ type: 'SET_USER', payload: session.user?.user });
      dispatch({ type: 'SET_JWT', payload: session.user?.token });
      navigate('/');

    } catch (error) {
      //
    }
    setIsLoading(false);
  }

  return {
    form,
    isLoading,
    isValidForm,
    onChange,
    onSubmit: submit,
  };
}

export default Login;